<template>
  <v-card
    class="elevation-0"
    style="height:100%; background-color: #fff !important"
  >
    <v-card-text style="padding: 16px">
      <v-container fluid>
        <v-layout class="stages" row wrap>
          <v-flex class="nav" xs6>
            <div
              :key="stage.name"
              @click="$router.push(stage.to)"
              v-for="(stage, index) in stages.filter((s, i) => i % 2 === 0)"
            >
              <div class="seq">{{ 2 * index + 1 }}</div>
              <div class="name">{{ $t(`menus.${stage.to}`) }}</div>
            </div>
          </v-flex>
          <v-flex class="nav" style="padding-top:50px;" xs6>
            <div
              :key="stage.name"
              @click="$router.push(stage.to)"
              v-for="(stage, index) in stages.filter((s, i) => i % 2 === 1)"
            >
              <div class="seq">{{ 2 * (index + 1) }}</div>
              <div class="name">{{ $t(`menus.${stage.to}`) }}</div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      stages: this.$store.state.stages,
    }
  },
  methods: {},
  mounted() {
    console.log(this.$store.getters.user.userAccountId)
  },
}
</script>

<style scoped>
.nav {
  display: flex;
  flex-direction: column;
}
.seq {
  font-size: 28px;
  font-family: Arial;
  font-weight: 100;
  color: #999;
  position: absolute;
  left: 15px;
  bottom: 0px;
}

.nav > div {
  margin-bottom: 20px;
  padding: 5px;
  height: 80px;
  width: 100%;
  background: transparent url('../../assets/img/home/right/d.png') no-repeat 0%
    100%;
  border: 1px solid #ccc;
  position: relative;
}
.nav > div:hover {
  background: #f1f1f1 url('../../assets/img/home/right/d.png') no-repeat 0% 100%;
}
</style>
